import { Icon } from "@iconify/react";
import { LanguagesIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuRadioGroup, DropdownMenuRadioItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import type { AppLocale } from "@/locales/i18n";
import { useI18n } from "@/locales/i18n-provider";

export function LanguageToggle() {
  const { locale, setLocale, t } = useI18n();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button aria-label={t("language.switch")} className="size-10 rounded-xl" size="icon" variant="ghost">
          <LanguagesIcon />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuRadioGroup value={locale} onValueChange={(value) => setLocale(value as AppLocale)}>
          <DropdownMenuRadioItem value="zh-Hans">
            <Icon icon="twemoji:flag-china" />
            中文
          </DropdownMenuRadioItem>
          <DropdownMenuRadioItem value="en">
            <Icon icon="twemoji:flag-united-kingdom" />
            English
          </DropdownMenuRadioItem>
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
